export default __webpack_public_path__ + "static/media/check.d644c682.svg";